<template>
  <section class="max-w-xl mx-auto">
    <div class="flash flash--inline flash--warning">
      <strong v-text="'Warning:'" />
      <span v-text="warningText" />
    </div>
    <div class="flex-row flex">
      <MembershipList
        class="w-1/4"
        :selected-memberships="selectedMemberships"
      />
      <div class="w-3/4 mx-4">
        <SelectPermissions
          :pre-selected="edits"
          is-disabled
          show-as-list
        />
      </div>
    </div>
    <div class="my-6 flex justify-center">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-primary btn"
        @click.prevent="handleConfirm"
        v-text="'Set new permissions'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'
import MembershipList from './MembershipList'
import SelectPermissions from './SelectPermissions'

export default {
  name: 'ConfirmPermissions',
  components: {
    SelectPermissions,
    MembershipList,
  },
  mixins: [
    TabNavigation,
    HasSelectedMemberships,
  ],
  props: {
    edits: {
      type: Object,
      required: true,
    },
    editTarget: {
      type: String,
      required: true,
    },
  },
  computed: {
    warningText() {
      return this.selectedMemberships.length === 1
        ? 'All permissions will be overwritten and replaced with those selected below for 1 member.'
        : `All permissions will be overwritten and replaced with those selected below for ${this.selectedMemberships.length} selected members.`
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirmed')
    },
  },
}
</script>
